module.exports = __webpack_public_path__ + "static/img/xiadawei.316ec77.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/xiadawei.png
// module id = /1a5
// module chunks = 0